<template>
<div>
    <section v-if="!hide" :class="['box-typical', 'files-manager']">
        <div ref="content-container" class="files-manager-panel">
            <div class="files-manager-panel-in ml-0" >
                <header class="files-manager-header p-2">
                    <div class="files-manager-header-left">
                        <div class="search">
                            <input type="text"
                                v-model="search"
                                class="form-control form-control-rounded"
                                placeholder="Search"/>
                            <button type="submit" class="btn-icon"><i class="font-icon font-icon-search"></i></button>
                        </div>
                    </div>
                    <div class="files-manager-header-right mt-1">
                        <!-- <div class="views">
                            <button type="button" class="btn-icon view active"><i class="font-icon font-icon-view-grid"></i></button>
                            <button type="button" class="btn-icon view"><i class="font-icon font-icon-view-rows"></i></button>
                        </div> -->
                        <div class="header-buttons p-0">
                            <button v-on:click="showUploadModal"
                                    type="button" class="btn btn-rounded btn-sm">
                                <!-- <img src="/img/icons/upload.svg" alt="Upload" class="icon"> -->
                                <i class="material-icons">cloud_upload</i>
                                Upload Asset
                            </button>
                            <button v-on:click="createFolder"
                                    type="button" class="btn btn-rounded btn-success btn-sm">
                                <i class="material-icons">create_new_folder</i>
                                New Folder
                            </button>
                            <button type="button"
                                v-on:click="updateCache"
                                :disabled="updatingCache"
                                :class="['btn', 'btn-rounded', 'btn-default', 'btn-sm', updatingCache ? 'btn--state-loading' : '']">
                                <i class="material-icons">cached</i>
                                {{ updatingCache ? 'Updating...' : 'Refresh' }}
                            </button>
                        </div>
                    </div>
                </header><!--.files-manager-header-->

                <div class="files-manager-content">
                    <section class="files-manager-aside w-100">
                        <h3>
                            <drop v-for="(node, idx) in assetPath" tag="span" :key="node.id"
                                v-on:drop="(fromId) => onMoveAsset(node.id, fromId, node.isStorage)">
                                <i v-if="idx > 0" class="material-icons mr-0">keyboard_arrow_right</i>
                                <a v-if="!node.isCurrent" v-on:click="onPathClick(node.id, node.isStorage)" href="javascript:void(0)">
                                    {{ node.label || __(node.name, ['titleCase']) }}
                                </a>
                                <span v-else>{{ node.label || __(node.name, ['titleCase']) }}</span>
                            </drop>
                        </h3>
                    </section>
                    <div class="files-manager-content-in scrollable-block asset-modal" >
                        <!-- temporarily hide the storage panel -->
                        <nav :class="['files-manager-side', showStoragePanel ? '' : 'hide']">
                            <header class="files-manager-side-title">Storage</header>
                            <ul class="files-manager-side-list">
                                <li v-for="storage in storageList" :key="storage.name">
                                    <a v-on:click="selectStorage(storage.name)"
                                        :class="[storage.name === currentStorage ? 'active' : '']"
                                        style="border-bottom: 0px">
                                        <i v-if="storage.icon" class="material-icons">{{ storage.icon }}</i>
                                        {{ storage.label || __(storage.name, ['titleCase']) }}
                                        <small v-if="storage.description" class="d-block" v-html="storage.description"></small>
                                    </a>
                                </li>
                            </ul>
                        </nav><!--.files-manager-side-->
                        <!-- pagination -->
                        <div class="row mt-3 mr-3">
                            <div class="col">
                                <select v-model="sortBy" class="form-control w-100">
                                    <option v-for="option in sortOptions" :value="option.id">{{ option.name }}</option>
                                </select>
                            </div>
                            <div class="col">
                                <b-pagination
                                    v-if="pagination.last_page > 1"
                                    v-model="pagination.current_page"
                                    align="right" size="md" :limit="6"
                                    :total-rows="pagination.total"
                                    :per-page="pagination.per_page"
                                    ></b-pagination>
                            </div>
                        </div>
                        <div :class="['fm-file-container', showStoragePanel ? 'fm-file-padded' : '']">
                            <div class="fm-file-grid" v-on:click="resetSelect" >
                            <div class="fm-file-grid-in">
                                <!-- render folders -->
                                <div v-for="asset in inViewFolders"
                                    v-on:click="(e) => { e.stopPropagation(); checkAndSelectAsset(asset); }"
                                    v-on:dblclick="(e) => { e.stopPropagation(); checkAndGetAsset(asset); }"
                                    :key="asset.id"
                                    :class="['fm-file', 'fm-folder', (isAssetSelected(asset) || asset.id == dragging) ? 'selected' : '']">
                                    <drag :transfer-data="asset.id">
                                        <input v-if="isAssetSelected(asset)" type="checkbox" class="checkbox" :checked="isAssetSelected(asset)">
                                        <div class="file-border">
                                            <drop
                                                v-on:dragover="(fromId) => onMoveAssetOver(asset.id, fromId, false)"
                                                v-on:dragleave="(fromId) => onMoveAssetLeave(asset.id, fromId, false)"
                                                v-on:drop="(fromId) => onMoveAsset(asset.id, fromId, false)">
                                                <div class="fm-file-icon">
                                                    <img src="/img/folder.svg" alt="Folder" />
                                                </div>
                                                <div class="fm-file-name"><p>{{asset.name}}</p></div>
                                                <div class="fm-file-size">{{getFolderSize(asset.id)}} files</div>
                                            </drop>
                                        </div>
                                    </drag>
                                </div>

                                <!-- render files -->
                                <div v-for="asset in inViewFiles"
                                    v-on:click="(e) => { e.stopPropagation(); checkAndSelectAsset(asset); }"
                                    v-on:dblclick="(e) => { e.stopPropagation(); checkAndGetAsset(asset.id); }"
                                    :key="asset.id"
                                    :class="[
                                        'fm-file asset',
                                        checkExtension(asset) ? '' : 'disabled',
                                        isAssetSelected(asset) ? 'selected' : '',
                                    ]">
                                    <drag :transfer-data="asset.id">
                                        <input type="checkbox" class="checkbox" :checked="isAssetSelected(asset)">
                                        <div class="file-border">
                                            <div class="fm-file-icon">
                                                <img :src="getIcon(asset)" alt="" />
                                            </div>
                                            <div class="fm-file-name"><p>{{asset.name}}</p></div>
                                            <div class="fm-file-dimension">{{getDimension(asset)}}</div>
                                            <div class="fm-file-size">{{getFileSize(asset.size)}}</div>
                                        </div>
                                    </drag>
                                </div>

                            </div>
                            </div>
                        </div>

                    </div><!--.files-manager-content-in-->
                </div><!--.files-manager-content-->
                <section class="files-manager-aside" >
                    <h3><i class="material-icons">build</i>Toolbar</h3>
                    <div v-if="assetInfo" class="files-manager-aside-section">
                        <div v-if="currentAssets.length > 0" class="text-center">
                            <div class="box-typical-header-cm">
                                <p class="asset-name">{{ assetInfo.name }}</p>
                            </div>
                            <button v-on:click="deleteAssets" class="btn btn-rounded btn-md btn-danger">
                                <!-- <i class="font-icon-left font-icon-trash"></i> -->
                                <i class="material-icons">delete</i>
                                Delete selected
                            </button>
                        </div>
                        <template v-else>
                            <div class="box-typical-header-sm">
                                <inline-input-component
                                    v-on:change="updateAssetName"
                                    :initialValue="assetInfo.name"
                                    class="asset-name"
                                    ></inline-input-component>
                            </div>
                            <img v-if="getFiletype(assetInfo.extension) == 'img'"
                                :src="_.imgPath(assetInfo, 'w264') + '?' + timestamp" class="w-100" v-on:load="adjustHeight" />
                            <img v-if="getFiletype(assetInfo.extension) == 'pdf'"
                                :src="_.imgPath(assetInfo) + '?' + timestamp" class="w-100" v-on:load="adjustHeight" />
                            <div class="info-list">
                                <table class="table-sidebar" width="100%">
                                    <tr>
                                        <td>System ID</td>
                                        <td class="text-right">{{ assetInfo.id }}</td>
                                    </tr>
                                    <tr>
                                        <td>Created</td>
                                        <td class="text-right">{{__(assetInfo.created_at, ['datetime'])}}</td>
                                    </tr>
                                    <tr>
                                        <td>Dimension</td>
                                        <td class="text-right">{{getDimension(assetInfo)}}</td>
                                    </tr>
                                    <tr v-if="['dir'].indexOf(assetInfo.extension) >= 0">
                                        <td >Files</td>
                                        <td class="text-right">{{getFolderSize(assetInfo.id)}}</td>
                                    </tr>
                                    <tr v-else>
                                        <td>Size</td>
                                        <td class="text-right">{{getFileSize(assetInfo.size)}}</td>
                                    </tr>
                                    <!-- <tr> -->
                                    <!--     <td>Description</td> -->
                                    <!--     <td class="text-right">{{assetInfo.description}}</td> -->
                                    <!-- </tr> -->
                                    <!-- <tr> -->
                                    <!--     <td>Keywords</td> -->
                                    <!--     <td class="text-right">{{assetInfo.keywords}}</td> -->
                                    <!-- </tr> -->
                                    <tr>
                                        <td>Extension</td>
                                        <td class="text-right">{{assetInfo.extension}}</td>
                                    </tr>
                                    <tr>
                                        <td>Creator</td>
                                        <td class="text-right"></td>
                                    </tr>
                                    <template v-if="_.values(assetInfo.usage).length > 0">
                                        <tr><td>Used</td><td class="text-right"></td></tr>
                                        <tr>
                                            <td colspan=2>
                                                <table style="font-size: .65rem; font-weight: initial; width: 100%;">
                                                    <tbody>
                                                        <tr v-for="trHtml in getUsageHtml(assetInfo)" v-html="trHtml"></tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </template>
                                    <tr v-else>
                                        <td>Used</td><td class="text-right">---</td>
                                    </tr>
                                </table>
                            </div>

                            <div class="files-manager-aside-section-button">
                                <button
                                    v-if="assetInfo.extension != 'dir'"
                                    v-on:click="cacheAsset(assetInfo)"
                                    class="btn btn-secondary btn-block btn-rounded ">
                                    <i class="material-icons">restore</i>
                                    Cache Asset
                                </button>

                                <button
                                    v-if="assetInfo.extension != 'dir'"
                                    v-on:click="showAssetReplacePrompt"
                                    class="btn btn-secondary btn-block btn-rounded ">
                                    <!-- <img src="/img/icons/replace-bl.svg" alt=""> -->
                                    <i class="material-icons">find_replace</i>
                                    Replace Asset
                                    <input type='file'
                                        v-on:change="(e) => replaceAsset(assetInfo, e)"
                                        ref="fm-replace-asset"
                                        class="hide">
                                </button>

                                <button
                                    v-if="assetInfo.extension != 'dir'"
                                    v-on:click="copyClipboard(_.assetPath(assetInfo))"
                                    class="btn btn-secondary btn-block btn-rounded ">
                                    <i class="material-icons">content_copy</i>
                                    Copy URL
                                </button>

                                <a v-if="imageEditable && _.includes(editableExtensions, assetInfo.extension)"
                                    :href="'#' + assetInfo.link"
                                    class="btn btn-rounded btn-block mb-1 ">
                                    <i class="material-icons">edit</i>
                                    Edit Image
                                </a>

                                <a v-if="assetInfo.extension !== 'dir'"
                                    :href="assetInfo.link + '?download'"
                                    target="_blank"
                                    class="btn btn-rounded btn-block mb-1 ">
                                    <i class="font-icon-left font-icon-download-3"></i>
                                    <!-- <i class="material-icons">content_copy</i> -->
                                    Download
                                </a>
                                <button v-on:click="deleteAsset" class="btn btn-block btn-rounded btn-danger">
                                    <!-- <i class="font-icon-left font-icon-trash"></i> -->
                                    <i class="material-icons">delete</i>
                                    Delete
                                </button>
                            </div>
                        </template>
                    </div>
                </section><!--.files-manager-aside-->
            </div><!--.files-manager-panel-in-->
        </div><!--.files-manager-panels-->

    </section><!--.files-manager-->
    <upload-modal-component
        :extensions="extensions"
        :uploadFile="uploadFile"
        v-on:modal-close="hideUploadModal"
        :active="isUploading"></upload-modal-component>
</div>
</template>
<script>
import Vue from 'vue';
import V from 'voca';
import URI from 'urijs';
import filesize from 'filesize';
import clipboard from 'clipboard-polyfill';
import * as paginator from '../utils/paginator';

import { Drag, Drop } from 'vue-drag-drop';
import UploadModalComponent from './helpers/UploadModalComponent';
import InlineInputComponent from './helpers/InlineInputComponent';

export default {
    data() {
        const currentStorage = _.get(this.content, 'meta.defaultStorage');
        const currentAsset = _.chain(this.content)
            .get('data', [])
            .find(item => item.id == this.currentValue)
            .value();

        return {
            sortBy: 'updated_at:desc',
            currentAsset: _.get(currentAsset, 'id'),
            currentAssets: [],
            currentParent: _.get(currentAsset, 'parent_id'),
            currentStorage,
            isUploading: false,
            extensionMap: {},
            extensions: [],
            editableExtensions: ['png', 'jpeg', 'jpg'],
            dragging: null,
            search: null,
            updatingCache: false,
            pagination: {
                last_page: 1,
                current_page: 1,
                total: 0,
                per_page: this.per_page || 50,
            }
        }
    },

    props: [
        'content', 'timestamp', 'loading', 'showLoading', 'query', 'resourceParams',
        'changeUrl', 'changeQuery', 'changeSection', 'allowedExtensions', 'currentValue',
        'getData', 'updateData', 'deleteData', 'createData',
        'updateBatch', 'addNotification', 'replaceData', 'updateCollection',
        'multiple', 'storagePanel', 'storages', 'per_page', 'embedded', 'hide',
    ],

    components: {
        UploadModalComponent,
        InlineInputComponent,
        Drag, Drop,
    },

    watch: {
        timestamp: {
            handler() {
                const extensionMap = this.config('file.extensions', {});
                const extensions = this.allowedExtensions || _.chain(extensionMap).values().flatten().value();

                this.extensionMap = extensionMap;
                this.extensions = extensions;
            },
            immediate: true,
        },

        currentStorage() {
            this.currentAsset = null;
            this.currentParent = null;
            this.pagination.current_page = 1;
        },

        currentParent() {
            this.pagination.current_page = 1;
        },

        allowedExtensions(newVal) {
            this.extensions = newVal;
        },

        currentValue(newAssetId) {
            const asset = _.chain(this.content).get('data').find(asset => asset.id == newAssetId).value();
            this.currentAsset = newAssetId;
            this.currentParent = _.get(asset, 'parent_id', null);
            this.currentStorage = _.get(asset, 'storage', _.get(this.content, 'meta.defaultStorage'));

            const assetIndex = _.chain(this.totalInViewAssets).findIndex(asset => asset.id == newAssetId).value();
            this.pagination.current_page = paginator.getPage(this.pagination, assetIndex);
        },

        search(newQuery) {
            this.pagination.current_page = 1;
        },

        totalInViewAssets: {
            handler(newData) {
                if (this.pagination.total != _.size(newData)) {
                    this.pagination = paginator.paginate(newData, this.pagination);
                }
            },
            immediate: true,
        },

        sortBy() {
            this.$forceUpdate()
        },
    },

    computed: {
        assetConfig() {
            return this.config('component_mapping.assets', {});
        },
        imageEditable() {
            return _.get(this.assetConfig, 'imageEditable');
        },
        assetInfo() {
            if (this.currentAssets.length > 0) {
                const count = this.currentAssets.length;
                return {
                    id: '_assets',
                    name: `${count} files selected`,
                    extension: 'col',
                    size: count,
                }
            }
            return this.content.data.find(asset => asset.id === this.currentAsset);
        },
        totalInViewAssets() {
            const sortBy = _.chain(this.sortOptions)
                .find(option => option.id == this.sortBy)
                .value() || _.first(this.sortOptions);

            const assets = _.chain(this.content.data)
                .filter(asset => {
                    const searchContent = [
                        _.get(asset, 'id', ''),
                        _.get(asset, 'name', ''),
                        _.get(asset, 'extension', ''),
                    ].join(' ');

                    return searchContent.toLowerCase().indexOf((this.search || '').toLowerCase()) >= 0;
                })
                .filter(asset => asset.storage === this.currentStorage)
                .filter(asset => asset.parent_id == this.currentParent)
                .map(asset => {
                    if (asset.extension == 'dir') {
                        asset.priority = 0;
                    } else {
                        asset.priority = 1;
                    }

                    return asset;
                })
                .thru(sortBy.handler)
                .sortBy(a => a.extension != 'dir')
                .value();

            return assets;
        },
        inViewAssets() {
            return paginator.slice(this.pagination, this.totalInViewAssets);
        },
        inViewFolders() {
            return this.inViewAssets.filter(asset => asset.extension == 'dir');
        },
        inViewFiles() {
            return this.inViewAssets.filter(asset => asset.extension != 'dir');
        },
        assetPath() {
            const currentStorage = _.find(this.storageList, (st) => st.name == this.currentStorage);
            const storageNode = {
                id: currentStorage.name,
                name: currentStorage.name,
                label: currentStorage.label,
                isStorage: true,
            };
            const dirPaths = [];

            let parentDirId = this.currentParent;
            while (parentDirId) {
                const parentAsset = this.content.data.find(asset => asset.id == parentDirId);
                if (parentAsset) {
                    dirPaths.unshift({
                        id: parentAsset.id,
                        name: parentAsset.name,
                        isStorage: false,
                    });
                    parentDirId = parentAsset.parent_id;
                }
            }

            const currentAsset = this.content.data.find(asset => asset.id == this.currentAsset);

            dirPaths.unshift(storageNode);
            _.last(dirPaths).isCurrent = true;

            return dirPaths.map(node => ({ ...node, name: this.shorten(node.name) }));
        },

        showStoragePanel() {
            let storagePanel = this.storagePanel
                || this.getConfig(['componentMapping', 'assets', 'storagePanel'])
                || false;

            return storagePanel;
        },

        storageList() {
           let storages = this.storages
                || this.getConfig(['componentMapping', 'assets', 'storages'])
                || _.get(this.content, 'meta.storages')
                || [];

            if (_.isFunction(storages)) {
                storages = storages.call(this);
            }

            return _.map(storages, (storage) => {
                if (_.isObject(storage)) return storage;

                return { name: storage };
            });
        },

        sortOptions() {
            return [
                {
                    id: 'updated_at:desc',
                    name: 'Sort By Date: Latest',
                    handler: (data) => _.sortBy(data, ['updated_at']).reverse(),
                },
                {
                    id: 'updated_at:asc',
                    name: 'Sort By Date: Oldest',
                    handler: (data) => _.sortBy(data, ['updated_at']),
                },
                {
                    id: 'name:asc',
                    name: 'Sort By Name: A-Z',
                    handler: (data) => _.sortBy(data, ['name']),
                },
                {
                    id: 'name:desc',
                    name: 'Sort By Name: Z-A',
                    handler: (data) => _.sortBy(data, ['name']).reverse(),
                },
                {
                    id: 'size:asc',
                    name: 'Sort By Size: Low - High',
                    handler: (data) => _.sortBy(data, ['size']),
                },
                {
                    id: 'size:desc',
                    name: 'Sort By Size: High - Low',
                    handler: (data) => _.sortBy(data, ['size']).reverse(),
                },
            ]
        },
    },

    mounted() {
        console.log('Component mounted.')
        this.$emit('content::initialized', {
            name: 'asset-manager-component',
            type: this.content.type,
            config: this.assetConfig,
        });

        window._keydownListener = (e) => {
            this.keydownListener(e);
        }
        window._keyupListener = (e) => this.keyupListener(e);
        window.addEventListener('keydown', window._keydownListener);
        window.addEventListener('keyup', window._keyupListener);

        window.addEventListener('resize', () => {
            this.adjustHeight();
        })
    },

    destroyed() {
        window.removeEventListener('keydown', window._keydownListener);
        window.removeEventListener('keyup', window._keyupListener);
    },

    methods: {
        keydownListener(event) {
            if (['Meta', 'Control'].indexOf(event.key) >= 0) {
                window._isMeta = true;
            }

            if (event.key == 'shift') {
                window._isShift = true;
            }
        },

        keyupListener(event) {
            if (['Meta', 'Control'].indexOf(event.key) >= 0) {
                window._isMeta = false;
            }

            if (event.key == 'shift') {
                window._isShift = false;
            }
        },

        adjustHeight(e) {
            const container = this.$refs['content-container'];
            if (!container) return;

            const grid = container.querySelector('.fm-file-grid');
            const innerGrid = container.querySelector('.fm-file-grid-in');
            const fileContainer = container.querySelector('.fm-file-container');
            const sidebar = container.querySelector('.files-manager-aside-section');

            const gridHeight = _.get(innerGrid, 'clientHeight', 0);
            const sidebarHeight = _.get(sidebar, 'clientHeight', 0);

            if (gridHeight < sidebarHeight) {
                _.set(fileContainer, 'style.height', `${sidebarHeight}px`);
                _.set(grid, 'style.height', `${sidebarHeight}px`);
            } else {
                _.set(fileContainer, 'style.height', `auto`);
                _.set(grid, 'style.height', `auto`);
            }
        },

        selectStorage(name) {
            this.currentStorage = name;
            this.currentParent = null;
        },

        checkAndSelectAsset(asset) {
            if (!this.checkExtension(asset)) {
                return;
            }

            this.selectAsset(asset.id);
        },

        selectAsset(id) {
            if (this.multiple && window._isMeta) {
                if (this.currentAsset && this.currentAsset != '_assets') {
                    this.currentAssets = _.concat(this.currentAssets, this.currentAsset);
                }
                if (_.indexOf(this.currentAssets, id) >= 0) {
                    this.currentAssets = _.pull(this.currentAssets, id);
                } else {
                    this.currentAssets = _.concat(this.currentAssets, id);
                }
                this.currentAsset = '_assets';
                this.$emit('fm::asset::select', {
                    id: '_assets',
                    data: this.currentAssets
                        .map(assetId => {
                            const asset = this.content.data.find(item => item.id == assetId);
                            return asset;
                        })
                        .filter(asset => _.indexOf(this.allowedExtensions, asset.extension) >= 0),
                })
                this.$forceUpdate();
                this.$nextTick(this.adjustHeight);
                return;
            }

            const asset = this.content.data.find(asset => asset.id === id);
            this.currentAsset = id;
            this.currentAssets = [];
            this.$emit('fm::asset::select', asset)
            this.$forceUpdate();
            this.$nextTick(this.adjustHeight);
        },

        resetSelect() {
            if (this.multiple && window._isMeta) {
                return;
            }
            this.currentAsset = null;
            this.currentAssets = [];
        },

        checkAndGetAsset(asset) {
            if (!this.checkExtension(asset)) {
                return;
            }

            this.getAsset(asset.id);
        },

        getAsset(id) {
            const asset = this.content.data.find(asset => asset.id === id);

            if (asset.extension === 'dir') {
                this.currentParent = id;
            } else {
                this.$emit('fm::asset::dblclick', asset)
                // window.open(asset.link, '_blank');
            }
        },

        upOneLevel() {
            const parent = this.content.data.find(asset => asset.id == this.currentParent);

            this.currentParent = parent.parent_id;
        },

        createFolder() {
            this.createData({
                storage: this.currentStorage,
                parent_id: this.currentParent || '',
            }, {
              addToCollection: true,
            });
        },

        deleteAsset() {
            if (!confirm('Are you sure to delete this asset?')) {
                return;
            }

            this.updateBatch([
                { id: this.assetInfo.id, $delete: true },
            ])
        },

        deleteAssets() {
            if (!confirm('Are you sure to delete these assets?')) {
                return;
            }

            this.updateBatch(this.currentAssets.map(id => ({ id, $delete: true })))
        },

        uploadFile(data, upload = true) {
            return this.createData({
                ...data,
                parent_id: this.currentParent || '',
                storage: this.currentStorage || '',
            }, {
                upload,
                addToCollection: true,
            });
        },

        updateAssetName(value) {
            const { id } = this.assetInfo;
            this.updateBatch([
                { id, $update: { name: value } }
            ]);
        },

        showUploadModal() {
            this.isUploading = true;
            const documentBody = document.getElementsByTagName('body')[0];
            documentBody.classList.add('modal-open');
        },

        hideUploadModal() {
            this.isUploading = false;
            const documentBody = document.getElementsByTagName('body')[0];
            documentBody.classList.remove('modal-open');
        },

        onPathClick(id, isStorage = false) {
            if (isStorage) {
                this.currentStorage = id;
                this.currentParent = null;
                return;
            }
            const asset = this.content.data.find(asset => asset.id == id);
            this.currentAsset = asset.id;
            this.currentParent = asset.id;
        },

        onMoveAsset(toId, fromId, isStorage = false) {
            this.dragging = null;

            // handle droping collection here
            if (this.currentAssets.length > 0) {
                let data = {};
                if (isStorage) {
                    data = { parent_id: null, storage: toId }
                } else {
                    data = { parent_id: toId }
                }
                return this.updateBatch(this.currentAssets
                    .filter(assetId => assetId != toId)
                    .map(assetId => {
                        return { id: assetId, $update: data }
                    }))
            }

            if (toId == fromId) return;

            if (isStorage) {
                return this.updateBatch([
                    { id: fromId, $update: { parent_id: null, storage: toId } }
                ])
            }
            this.updateBatch([
                { id: fromId, $update: { parent_id: toId } }
            ]);
        },

        onMoveAssetOver(toId, fromId, isStorage = false) {
            if (isStorage) return;
            this.dragging = toId;
        },

        onMoveAssetLeave(toId, fromId, isStorage = false) {
            if (isStorage) return;
            this.dragging = null;
        },

        titleCase(val) {
            return V.titleCase(val);
        },

        shorten(val) {
            return val.length > 20 ? (val.slice(0, 15) + '...') : val;
        },

        getFileSize(val) {
            return filesize(val);
        },

        getFolderSize(id) {
            return this.content.data.filter(asset => asset.parent_id == id).length;
        },

        isAssetSelected(asset) {
            return asset.id === this.currentAsset || this.currentAssets.indexOf(asset.id) >= 0
        },

        getIcon(asset) {
            const extension = asset.extension;

            const iconExtPair = _.chain(this.extensionMap)
                .toPairs()
                .find(([icon, exts]) => exts.indexOf(extension) >= 0)
                .value();

            try {
                if (iconExtPair[0] == 'img') {
                    return _.imgPath(asset, 'w126_h126') + `?${this.timestamp}`;
                }
                if (iconExtPair[0] == 'pdf') {
                    return _.imgPath(asset) + `?${this.timestamp}`;
                }
                if (iconExtPair) {
                    return `/img/file-${iconExtPair[0]}.png`;
                }
            } catch (e) {
                console.log(iconExtPair);
            }

            return '/img/file.png';
        },

        getFiletype(extension) {
            const iconExtPair = _.chain(this.extensionMap)
                .toPairs()
                .find(([icon, exts]) => exts.indexOf(extension) >= 0)
                .value();
            return iconExtPair ? iconExtPair[0] : null;
        },

        getDimension(asset) {
            const { width, height } = asset;
            if (width && height) {
                return `${width}px x ${height}px`;
            }

            return '';
        },

        getUsageHtml(asset) {
            const { usage } = asset;
            let currentType;
            return _.chain(usage).toPairs()
                .sort((p1, p2) => p1.key > p2.key ? 1 : -1)
                .map(([key, label]) => {
                    const type = _.split(key, '.')[0];
                    const typeDisplay = this.__(type, ['titleCase']);

                    if (currentType != type) {
                        currentType = type;
                        return `<td></td><td class="align-top"><i class="mr-2">•</i>${typeDisplay}</td><td class="text-right"><small>${label}</small></td>`;
                    } else {
                        return `<td></td><td></td><td class="text-right"><small>${label}</small></td>`;
                    }
                }).value();
        },

        copyClipboard(value) {
            const origin = window.location.origin;
            clipboard.writeText(origin + URI(value).path());
            this.addNotification({
                type: 'message',
                message: 'Copied to clipboard!',
            });
        },

        updateCache() {
            this.updatingCache = true;
            return this.getData()
                .then(() => this.updatingCache = false);
        },

        showAssetReplacePrompt() {
            const fileInput = this.$refs['fm-replace-asset'];
            fileInput.click();
        },

        replaceAsset(asset, e) {
            e.preventDefault();
            const file = e.target.files[0];
            this.helpers('api').uploadData(asset.link, {}, { file })
                .then(response => {
                    this.replaceData(response);
                    this.addNotification({
                        type: 'message',
                        message: 'Asset updated successfully!',
                    });
                })
                .catch(error => {
                    this.addNotification({
                        type: 'error',
                        message: _.get(error, 'response.data.message', 'Cannot update asset'),
                    })
                })
        },

        checkExtension(asset) {
            return _.concat(this.extensions, ['dir']).indexOf(asset.extension) >= 0;
        },

        cacheAsset(asset) {
            // hide running command to clear image cache
            return this.helpers('api').runCommand('image:cache', {}, { ids: asset.id })
                .then(() => {
                    this.addNotification({
                        type: 'message',
                        message: `Command ${name} finish`,
                    });

                    this.$forceUpdate();
                })
        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/AssetManagerComponent.vue